import type { FC } from 'react';

export const CubeIcon: FC<{
  color?: string;
}> = (props) => (
  <svg width="100%" height="100%" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M13.5915 5.27175L7.99993 8.50008L2.40609 5.2666"
      stroke={props.color ?? '#E6E6E9'}
      stroke-width="1.33333"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M8 8.5V14.5"
      stroke={props.color ?? '#E6E6E9'}
      stroke-width="1.33333"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M7.33333 2.21819C7.74587 1.98001 8.25413 1.98001 8.66667 2.21819L13.1069 4.78172C13.5194 5.0199 13.7735 5.46007 13.7735 5.93642V11.0635C13.7735 11.5398 13.5194 11.98 13.1069 12.2182L8.66667 14.7817C8.25413 15.0199 7.74587 15.0199 7.33333 14.7817L2.89317 12.2182C2.48063 11.98 2.2265 11.5398 2.2265 11.0635V5.93642C2.2265 5.46007 2.48063 5.0199 2.89317 4.78172L7.33333 2.21819Z"
      stroke={props.color ?? '#E6E6E9'}
      stroke-width="1.33333"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M5.66667 3.5L10.6667 6.5"
      stroke={props.color ?? '#E6E6E9'}
      stroke-width="1.33333"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);
